import {
  SET_TITHELIES,
  SET_TITHELY,
  CLEAR_TITHELIES,
  CLEAR_TITHELY,
  ADD_TITHELY,
  UPDATE_TITHELY,
  REMOVE_TITHELY,
} from './ActionTypes';

export const tithely = (state = {}, member) => {
  switch (member.type) {
    case SET_TITHELY:
      return member.payload;
    case UPDATE_TITHELY:
      if (state._id.toString() !== member.payload._id.toString()) {
        return state;
      }

      // Otherwise, this is the one we want - return an updated value
      return {
        ...state,
        ...member.payload,
      };
    case CLEAR_TITHELY:
      return {};
    default:
      return state;
  }
};

export default (state = [], member) => {
  switch (member.type) {
    case SET_TITHELIES:
      return member.payload;
    case ADD_TITHELY:
      return [...state, member.payload];
    case UPDATE_TITHELY:
      return state.map((item) => {
        if (item._id !== member.payload._id) {
          return item;
        }

        // Otherwise, this is the one we want - return an updated value
        return {
          ...item,
          ...member.payload,
        };
      });
    case REMOVE_TITHELY:
      return state.map((item) => {
        if (item._id !== member.payload._id) {
          return item;
        }

        // Otherwise, this is the one we want - return an updated value
        return {
          ...item,
        };
      });
    case CLEAR_TITHELIES:
      return [];
    default:
      return state;
  }
};
